import { FiMoon, FiSun } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      className={`flex h-10 w-10 items-center justify-center rounded-full border border-line text-muted transition hover:border-brand-300 hover:text-brand-600 dark:border-midnight-600 dark:text-subtle dark:hover:border-brand-500 dark:hover:text-brand-300 ${className}`}
    >
      {theme === 'dark' ? <FiSun size={18} /> : <FiMoon size={18} />}
    </button>
  );
}
